import { blue } from "@ant-design/colors"
import { faStarHalfStroke } from "@fortawesome/pro-duotone-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Space } from "antd"

type Props = {
  intercomSurveyId: number
  additionalText?: string
}

const SurveyFeedbackButton = ({ intercomSurveyId, additionalText }: Props) => {
  const button = <Button
    type="primary"
    size="small"
    onClick={() => window.Intercom('startSurvey', intercomSurveyId) }
    icon={<FontAwesomeIcon icon={faStarHalfStroke} />}
  >
    Give Feedback
  </Button>

  if (additionalText) {
    return <div style={{display: 'inline-block', border: `1px solid ${blue[8]}`, backgroundColor: blue[0], borderRadius: '10px', padding: '10px 20px'}}>
    <Space>
      <span>{additionalText}</span>
      {button}
    </Space>
  </div>
  }

  return button
}

export default SurveyFeedbackButton
